/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var OrganisationRole;
(function (OrganisationRole) {
    OrganisationRole["Admin"] = "ADMIN";
    OrganisationRole["Agency"] = "AGENCY";
    OrganisationRole["Customer"] = "CUSTOMER";
    OrganisationRole["LocationOwner"] = "LOCATION_OWNER";
    OrganisationRole["NetworkOwner"] = "NETWORK_OWNER";
})(OrganisationRole || (OrganisationRole = {}));
export function OrganisationRoleFromJSON(json) {
    return OrganisationRoleFromJSONTyped(json, false);
}
export function OrganisationRoleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function OrganisationRoleToJSON(value) {
    return value;
}
